import React, { useEffect, useState, useRef } from "react";
import { activities, post } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "@skeleton";
import ModalForGuest from "../ModalForGuest";
import { Link } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { IoIosChatboxes } from "react-icons/io";
import { FaTasks } from "react-icons/fa";
import { FaCube } from "react-icons/fa";
import { GoPersonFill } from "react-icons/go";
import FavoriteBorderSharpIcon from "@mui/icons-material/FavoriteBorderSharp";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
import axios from "../../API/axios";
import moment from "moment";
import { Tooltip } from "@mui/material";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";

const {
  timelinePhoto1: Activities_timeline_Photo1,
  timelinePhoto2: Activities_timeline_Photo2,
  timelinePhoto3: Activities_timeline_Photo3,
  timelinePhoto4: Activities_timeline_Photo4,
} = activities;

const Activities = ({ uid, getUserProfileStat }) => {
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const localeMap = {
    en: "en",
    ar: "ar",
    hi: "hi",
  };

  const locale = localeMap[language] || "en";

  //************************ Follower  List   ************************/
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [FollowerList, setFollowerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  console.log("FollowerList", FollowerList);
  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [currentYear, setCurrentYear] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [activeDate, setActiveDate] = useState(null); // yyyy-mm-dd key for open accordion

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
          document.documentElement.scrollHeight &&
        hasMoreData &&
        !nextBatchLoading &&
        !isLoading
      ) {
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);
  
  //************************Follower List ************************//
  //************************ Follow User Start  ************************//
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************ Follow User End  ************************//
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

    // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------
 //************************ Follower  List   ************************//
  const [followedId, setFollowedId] = useState("");
  const [isfollowed, setIsfollowed] = useState(false);
  const [activities, setActivities] = useState([]); 
  const ActivityList = async () => {
    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 20,
      langKey: language === "en" ? "" : language,
      year: currentYear || new Date().getFullYear(),
      month: currentMonth || new Date().getMonth() + 1,
      sessionId: sessionId,
    };

    try {
      if (page === 1) {
        setIsLoading(true);
      } else {
        setNextBatchLoading(true);
      }

      const res = await axios.post("/UserProfile/GetUserActivityTree", data);
      // support both wrapped and top-level shapes
      const payload = res?.data?.responseData || res?.data || {};
      const items = payload.items || [];
      // capture available months from API
      if (Array.isArray(payload.availableMonths) && payload.availableMonths.length) {
        setAvailableMonths(payload.availableMonths);
        // set current to latest available if not set
        const latest = payload.availableMonths[0];
        if (latest && (currentYear !== latest.year || currentMonth !== latest.month)) {
          // update to latest only if not initialized
          if (currentYear === null && currentMonth === null) {
            setCurrentYear(latest.year);
            setCurrentMonth(latest.month);
            // reset activities and page to refetch for latest month
            setActivities([]);
                setPage(1);
                setActiveDate(null);
                return;
          }
        }
      }

      if (res?.data?.status === "Warning") {
        setIsError(true);
      } else {
        setIsError(false);
        setActivities((prev) => (page === 1 ? items : [...prev, ...items]));

        const totalPages =
          payload.paging?.totalPages || res?.data?.totalPages || payload.totalPages;
        if (typeof totalPages === "number") {
          setHasMoreData(page < totalPages);
        } else {
          // fallback: if items length < pageSize assume no more data
          setHasMoreData(items.length === data.pageSize);
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 404) {
        setIsError(true);
      } else {
        setIsError(true);
      }
    } finally {
      setIsLoading(false);
      setNextBatchLoading(false);
    }
  };

  useEffect(() => {
    ActivityList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, currentYear, currentMonth]);

  const groupActivitiesByDate = (list) => {
    if (!Array.isArray(list)) return {};
    return list.reduce((acc, item) => {
      const d = new Date(item.time);
      const key = d.toISOString().split("T")[0];
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
  };

  const grouped = groupActivitiesByDate(activities);

  useEffect(() => {
    if (activities && activities.length && !activeDate) {
      const todayKey = new Date().toISOString().split("T")[0];
      if (grouped[todayKey]) setActiveDate(todayKey);
      else {
        const keys = Object.keys(grouped).sort((a, b) => new Date(b) - new Date(a));
        if (keys.length) setActiveDate(keys[0]);
      }
    }
  }, [activities]);

  // detect top-most visible date header and sync dropdown/accordion
  const scrollTimeout = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        try {
          const headers = Array.from(document.querySelectorAll('.Activities_Heading_Content h4[data-date]'));
          if (!headers.length) return;
          let closest = null;
          let closestDist = Infinity;
          headers.forEach((h) => {
            const rect = h.getBoundingClientRect();
            const dist = Math.abs(rect.top - 80); // target near top offset
            if (rect.top <= window.innerHeight && dist < closestDist) {
              closestDist = dist;
              closest = h;
            }
          });
          if (closest) {
            const dateKey = closest.getAttribute('data-date');
            if (dateKey && dateKey !== activeDate) {
              setActiveDate(dateKey);
            }
            const d = new Date(dateKey);
            const y = d.getFullYear();
            const m = d.getMonth() + 1;
            if (y !== currentYear || m !== currentMonth) {
              setCurrentYear(y);
              setCurrentMonth(m);
            }
          }
        } catch (e) {
          // ignore
        }
      }, 120);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activities, activeDate, currentYear, currentMonth]);

  const formatDateLabel = (dateKey) => {
    const d = new Date(dateKey);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday = d.toDateString() === today.toDateString();
    const isYesterday = d.toDateString() === yesterday.toDateString();
    if (isToday) return t("Today") || "Today";
    if (isYesterday) return t("Yesterday") || "Yesterday";
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  };

  // --- Custom Dropdown component (inline) ---
  const Dropdown = ({ months, value, onChange }) => {
    const [open, setOpen] = useState(false);
    const toggleRef = useRef(null);

    useEffect(() => {
      const onDocClick = (e) => {
        if (toggleRef.current && !toggleRef.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("click", onDocClick);
      return () => document.removeEventListener("click", onDocClick);
    }, []);

    const selected = months.find((m) => m.year === value.year && m.month === value.month) || months[0];

    const containerStyle = { width: "100%",  };
    const buttonStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "5px 16px",
      borderRadius: 0,
      border: "1px solid #e1e5ee",
      background: "#fff",
      fontSize: 16,
      cursor: "pointer",
      boxShadow: "none",
      width: "100%",
    };
    const menuStyle = {
      position: "absolute",
      top: "calc(100% + 5px)",
      right: 0,
      left: 0,
      maxHeight: 260,
      overflowY: "auto",
      background: "#fff",
      border: "1px solid #e1e5ee",
      borderRadius: 0,
      zIndex: 2000,
      padding: 8,
      width: "100%",

    };
    const itemStyle = {
      padding: "2px 4px",
      fontSize: 16,
      borderRadius: 0,
      cursor: "pointer",
      marginBottom: 6,
    };

    return (
      <div ref={toggleRef} style={containerStyle}>
        <button type="button" style={buttonStyle} onClick={() => setOpen((s) => !s)} aria-haspopup>
          <span>{selected ? `${new Date(selected.year, selected.month - 1).toLocaleString(undefined, { month: 'long', year: 'numeric' })} (${selected.totalCount})` : 'Select'}</span>
          <span style={{ marginLeft: 12 }}>▾</span>
        </button>
        {open && (
          <div style={menuStyle} role="listbox">
            {months.map((m) => (
              <div
                role="option"
                aria-selected={m.year === selected.year && m.month === selected.month}
                key={`${m.year}-${m.month}`}
                onClick={() => {
                  onChange(m.year, m.month);
                  setOpen(false);
                }}
                style={{
                  ...itemStyle,
                  background: m.year === selected.year && m.month === selected.month ? '#f0f6ff' : 'transparent',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>{new Date(m.year, m.month - 1).toLocaleString(undefined, { month: 'long', year: 'numeric' })}</div>
                  <div style={{ color: '#666' }}>({m.totalCount})</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
          <div className="Activities_Heading d-flex justify-content-between align-items-center">
            {/* <h2>{t("User Profile.Activities")}</h2> */}
            {availableMonths.length > 0 && (
              <div style={{ position: "relative", width: "100%"  }}>
                <Dropdown
                  months={availableMonths}
                  value={{ year: currentYear, month: currentMonth }}
                  onChange={(y, m) => {
                    setCurrentYear(y);
                    setCurrentMonth(m);
                    setActivities([]);
                    setPage(1);
                    setHasMoreData(true);
                    setActiveDate(null);
                  }}
                />
              </div>
            )}
          </div>

      {isLoading ? (
        <div className="mt-3">
          <ShimmerDiv height={250} width={"100%"} />
        </div>
      ) : isError ? (
        <div className="mt-2 text-center">
          <img src={post.errorSmall} alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="aboutMe  p-2">
         
          {Object.keys(grouped)
            .sort((a, b) => new Date(b) - new Date(a))
            .map((dateKey) => (
              <div className="Activities_Heading_Content" key={dateKey}>
                <h4
                  data-date={dateKey}
                  role="button"
                  onClick={() => {
                    const newKey = activeDate === dateKey ? null : dateKey;
                    setActiveDate(newKey);
                    // when user explicitly opens a date, sync month dropdown
                    if (newKey) {
                      const d = new Date(newKey);
                      setCurrentYear(d.getFullYear());
                      setCurrentMonth(d.getMonth() + 1);
                    }
                  }}
                  style={{ cursor: "pointer", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <span>{formatDateLabel(dateKey)}</span>
                  <span
                    aria-hidden
                    style={{
                      display: 'inline-block',
                      marginLeft: 12,
                      transition: 'transform 180ms ease',
                      transform: activeDate === dateKey ? 'rotate(90deg)' : 'rotate(0deg)',
                      fontSize: 16,
                      color: '#666'
                    }}
                  >
                    ▸
                  </span>
                </h4>

                <div
                  className="Activities_timeline"
                  style={{ display: activeDate === dateKey ? "block" : "none", maxHeight: 300, overflowY: "auto",
                            scrollbarWidth: "thin"
                        }}
                  onScroll={(e) => {
                    if (
                      e.currentTarget.scrollTop + e.currentTarget.clientHeight + 20 >=
                        e.currentTarget.scrollHeight &&
                      hasMoreData &&
                      !nextBatchLoading
                    ) {
                      setPage((p) => p + 1);
                    }
                  }}
                >
                  <ul className="ps-1">
                    {grouped[dateKey].map((item) => {
                      // Calculate relative time for this item
                      const now = moment();
                      const itemTime = moment(item.time);
                      const diffSeconds = now.diff(itemTime, "seconds");
                      const diffMinutes = now.diff(itemTime, "minutes");
                      const diffHours = now.diff(itemTime, "hours");
                      const diffDays = now.diff(itemTime, "days");
                      const diffMonths = now.diff(itemTime, "months", true);
                      const diffYears = now.diff(itemTime, "years", true);

                      let result = "";

                      if (diffSeconds < 60) {
                        result = t("Notifications.Just Now");
                      } else if (diffMinutes < 60) {
                        result =
                          diffMinutes === 1
                            ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                            : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                      } else if (diffHours < 24) {
                        result =
                          diffHours === 1
                            ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                            : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                      } else if (diffDays < 30) {
                        result =
                          diffDays === 1
                            ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                            : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                      } else if (diffMonths < 12) {
                        const displayMonth =
                          diffMonths >= 0.75 && diffMonths < 1.25
                            ? 1
                            : Math.round(diffMonths * 2) / 2;
                        result =
                          displayMonth === 1
                            ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                            : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                      } else {
                        const displayYear =
                          diffYears >= 0.75 && diffYears < 1.25
                            ? 1
                            : Math.round(diffYears * 2) / 2;
                        result =
                          displayYear === 1
                            ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                            : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                      }

                      return (
                        <li className="Activities_timeline-item" key={item.actionId}>
                          <div className="Activities_timeline-figure">
                            <span className="Activities_timeline-figure_inner">
                              <img src={Activities_timeline_Photo1} alt="" />
                            </span>
                          </div>
                          <div className="Activities_timeline-body">
                            <div className="Activities_timeline-body_MiddleContent">
                              <h1> {item.apiname || "Activity"} 
                                 {/* <div className="Activities_timeline-body_MiddleContent_Date">
                                </div> */}
                               </h1>
                                  <span >{item.remark || ""}</span>
                            </div>
                              <div className="Activities_timeline-body_MiddleContent_Date2">
                                <p >
                                 {language === "ar" ? (
                                             <Tooltip title={moment(item.time)
                                               .locale(locale)
                                               .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                               <p className="f-10 label">
                                                 {moment(item.time)
                                                   .locale(locale)
                                                   .format("D MMMM YYYY [الساعة] h:mm a")}
                                               </p>
                                             </Tooltip>
                                           ) : (
                                             <Tooltip title={moment(item.time)
                                               .format(language === "en"
                                                 ? "D MMMM YYYY [at] h:mm a"
                                                 : "D MMMM YYYY [को] h:mm a")} arrow>
                                               <p className="f-10 label"> 
                                                 {result}
                                               </p>
                                             </Tooltip>
                                           )}                               
                                </p>
                                {/* <p >{new Date(item.time).toLocaleTimeString()}</p> */}
                              </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            ))}
           {/* <div className="Activities_Heading_Content">
            <h4>Today</h4>
            <ul className="Activities_timeline">
            <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                       
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Ali shaikh Shaikh</Link>
                      <div className="Activities_timeline-body_MiddleContent_Date">
                        <span>liked your post</span>
                      </div>
                      </h6>
                        <div className="Activities_timeline-body_MiddleContent_Date2">
                          <p>3 hours ago</p>
                        </div>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Likeanddot">
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_Icon">
                        <FavoriteBorderSharpIcon className="ActivityHeartIcon" />
                      </div>
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_IconDot">
                        <MoreHorizSharpIcon className="ActivityDotIcon" />
                      </div>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                       
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Ali shaikh Shaikh</Link>
                      <div className="Activities_timeline-body_MiddleContent_Date">
                        <span>liked your post</span>
                      </div>
                      </h6>
                        <div className="Activities_timeline-body_MiddleContent_Date2">
                          <p>3 hours ago</p>
                        </div>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Likeanddot">
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_Icon">
                        <FavoriteBorderSharpIcon className="ActivityHeartIcon" />
                      </div>
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_IconDot">
                        <MoreHorizSharpIcon className="ActivityDotIcon" />
                      </div>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
          <div className="Activities_Heading_Content">
            <h4>Yesterday</h4>
            <ul className="Activities_timeline">
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <input type="checkbox" name="" id="" />{" "}
                        <Link to=""> Daily Report - Dealing targeting</Link>
                      </h6>
                      <p>
                        <Link>Arthur Carroll </Link>created a todo on task
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>8:14pm</span>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
          <div className="Activities_Heading_Content">
            <h4>January 25, 2018</h4>
            <ul className="Activities_timeline">
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <FaCube />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Project updated by Sara Carr</Link>
                      </h6>
                      <p>
                        <Link>Sara Carr</Link> updated <b>Online Store App</b>{" "}
                        to <Link>Online Store</Link>
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>3:21am</span>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <FaTasks />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Someone assigned you to a task</Link>
                      </h6>
                      <p>
                        <Link>Angela Peterson</Link> assign{" "}
                        <Link>Make lemonade from scratch</Link> to you
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>5:21pm</span>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <GoPersonFill />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">You have new followers</Link>
                      </h6>
                      <div className="Activities_timeline_Photo">
                        <a href="">
                          <img src={Activities_timeline_Photo1} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo2} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo3} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo4} alt="" />
                        </a>
                      </div>
                      <p>
                        <Link>Willie Dixon</Link> and 3 others followed you
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>10:32pm</span>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>   */}

        </div>
      )}
      {hasMoreData ? "" : <p className="text-center">{t("Newsfeed.No more data available")}</p>}
      {nextBatchLoading && (
        <div className="text-center mb-4">
          <img src={post?.loader} width={50} />
        </div>
      )}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Activities;
